
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/salary-compass",
      function () {
        return require("private-next-pages/salary-compass.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/salary-compass"])
      });
    }
  